/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { InventoryImage, FlexRow, FlexCol, Button, Box, Spacer } from 'sarsaparilla';
import EntryExitDateText from '../registration/EntryExitDateText';

export default class AlternateHolderSideDetail extends React.PureComponent {
    static propTypes = {
        acceptAlternateRequest: PropTypes.func,
        declineAlternateRequest: PropTypes.func,
        buttonDisabled: PropTypes.bool,
        divisionName: PropTypes.string,
        entryDate: PropTypes.any,
        exitDate: PropTypes.any,
        isLottery: PropTypes.bool,
        permit: PropTypes.object,
    };

    render() {
        return (
            <div
                data-testid="alternate-holder-side-detail"
                className="rec-order-summary per-order-summary"
            >
                <div className="rec-order-summary-media">
                    <InventoryImage type="asset" id={this.props.permit.id} />
                </div>
                <div className="rec-order-summary-item">
                    <div className="rec-order-summary-item-header">
                        <div className="rec-order-summary-item-title">
                            {this.props.permit.name}
                        </div>
                    </div>
                    <div className="rec-order-summary-item-body">
                        <EntryExitDateText
                            entryDate={this.props.entryDate}
                            exitDate={this.props.exitDate}
                            isLottery={this.props.isLottery}
                            permit={this.props.permit}
                        />
                        {!this.props.isLottery && (
                            <div className="rec-order-summary-item-dates">
                                <FlexRow>
                                    <FlexCol>
                                        <div className="rec-dates-label">Location</div>
                                        <div className="rec-dates-value">
                                            {this.props.divisionName}
                                        </div>
                                    </FlexCol>
                                </FlexRow>
                            </div>
                        )}
                    </div>
                </div>
                <Box className="p-2">
                    <Button
                        id="accept-alternate-button"
                        isDisabled={this.props.buttonDisabled}
                        onClick={this.props.acceptAlternateRequest}
                        size="lg"
                        shouldFitContainer
                    >
                        Accept & Send
                    </Button>
                    <Spacer size="xs" />
                    <Button
                        id="decline-alternate-button"
                        isDisabled={this.props.buttonDisabled}
                        onClick={this.props.declineAlternateRequest}
                        appearance="tertiary"
                        size="lg"
                        shouldFitContainer
                    >
                        Decline Request
                    </Button>
                </Box>
            </div>
        );
    }
}
